import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-general',
  templateUrl: './general.component.html',
  styleUrls: ['./general.component.css']
})
export class GeneralComponent implements OnInit {

  constructor(private titleService: Title, private metaTagService: Meta) { }

  ngOnInit(): void {
    this.titleService.setTitle('Zacházení s daty');
    this.metaTagService.updateTag(
      { name: 'description', content: 'Bezpečí uživatelských dat bereme vážně - heslo se pokaždé šifruje.'});
  }

}
